import { createSelector } from 'reselect';

export const termsAndConditionsSelector = createSelector(
  (state) => state.d_termsAndConditions,
  (termsAndConditions) => termsAndConditions
);
